export default "__VITE_ASSET__DLMl1VT3__"